module.exports = __webpack_public_path__ + "img/IELTSNgocBach.2d47828d.png";